import React from 'react';
import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';
import combineStyles from '../utils/combineStyles';
import { CONTAINER_PROPERTIES } from '../utils/theme';

interface RadioToggleProps {
  checked: boolean;
  onClick?: () => void;
  size?: number;
}

export const RadioToggle = ({ checked, onClick, size = 32 }: RadioToggleProps) => {
  const p = useAppSelector(getThemeLookup);
  const innerCircleSizeModifier = 0.55;

  return (
    <div onClick={onClick} style={styles.container}>
      <span
        style={combineStyles(
          styles.circle,
          p('radioToggleCircle', CONTAINER_PROPERTIES),
          checked && p('radioToggleCircleChecked', CONTAINER_PROPERTIES),
          {
            width: size,
            height: size,
          },
        )}
      >
        {checked && (
          <span
            style={combineStyles(
              styles.innerCircle,
              p('radioToggleInnerCircle', CONTAINER_PROPERTIES),
              {
                width: size * innerCircleSizeModifier,
                height: size * innerCircleSizeModifier,
              },
            )}
          />
        )}
      </span>
    </div>
  );
};

const styles: Styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: 10,
  },
  circle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
  innerCircle: {
    display: 'block',
    borderRadius: '50%',
  },
};
